import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { FaUserCircle, FaEnvelope, FaPhone, FaIdCard,FaUserMinus, FaBan, FaComments } from 'react-icons/fa'
import '../../assets/css/FollowersList.css'
import { Copy, Link, QrCode } from 'lucide-react'
import BiolinkQRCode from '../biolink-page/BiolinkQRCode'
import Badge from 'react-bootstrap/Badge';

export default function FollowerList({ followers, onBlock, onChat,onUnfollow, getProfileImage, chatNotificationData, getInitials }) {
    const [qrShow, setQRShow] = useState(false)
    const [qrCode, setQrCode] = useState(false)

    const handleQR = (data) => {
        setQrCode(data)
        setQRShow(true)
    }
    return (
        <>
            {followers && followers.length > 0 ? (
                <div className="followers-grid">
                    {followers.map((follower, index) => {
                        const profileImage = follower?.user?.profile?.profile_photo

                        // Handle potential 'undefined' strings and trailing spaces
                        const rawTitle = follower?.user?.profile?.title
                        const rawName = follower?.user?.name
                        const validTitle = (rawTitle && rawTitle !== 'undefined' && rawTitle !== 'null') ? rawTitle : null
                        const validName = (rawName && rawName !== 'undefined' && rawName !== 'null') ? rawName : null

                        const userName = (validTitle || validName || 'User').trim()
                        const initials = getInitials(userName)
                        const userId = follower?.user?.user_name
                        const userEmail = follower?.user?.email || 'N/A'
                        const unreadMsg = chatNotificationData?.find((item) => item?.sender_id === follower?.user?._id)
                        return (
                            <div key={index} className="follower-card">
                                <div className="follower-card-header">
                                    <div className="follower-profile-section">
                                        {profileImage ? (
                                            <img
                                                src={process.env.REACT_APP_BASE_URL + profileImage}
                                                alt={userName}
                                                className="follower-profile-image"
                                                onError={(e) => {
                                                    e.target.style.display = 'none'
                                                    e.target.nextSibling.style.display = 'flex'
                                                }}
                                            />
                                        ) : null}
                                        <div
                                            className="follower-profile-avatar"
                                            style={{ display: profileImage ? 'none' : 'flex' }}
                                        >
                                            {initials}
                                        </div>
                                        <div className="follower-profile-info">
                                            <h6 className="follower-name">{userName}</h6>

                                            <div className='d-flex align-items-center'>
                                                <a
                                                    className="btn btn_qr_code"
                                                    href={process.env.REACT_APP_BASE_URL + `x/${follower?.user?.user_name}`}
                                                    title="Copy URL"
                                                    target="_blank"
                                                >
                                                    <Link size={15} className='mb-1' />
                                                </a>
                                                <button
                                                    className='ms-2 btn btn_qr_code'
                                                    onClick={() => handleQR(follower)}
                                                    title="QR Code"
                                                >
                                                    <QrCode size={15} className='mb-1' />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="follower-card-body">
                                    <div className="follower-info-item">
                                        <FaIdCard className="follower-info-icon" />
                                        <div className="follower-info-content">
                                            <span className="follower-info-label">Username</span>
                                            <span className="follower-info-value">{userId || 'N/A'}</span>
                                        </div>
                                    </div>

                                    {/* <div className="follower-info-item">
                                        <FaEnvelope className="follower-info-icon" />
                                        <div className="follower-info-content">
                                            <span className="follower-info-label">Email</span>
                                            <span className="follower-info-value">{userEmail}</span>
                                        </div>
                                    </div> */}
                                </div>

                                <div className="follower-card-footer">
                                    <Button
                                        variant="warning"
                                        className="follower-action-btn follower-unfollow-btn"
                                        onClick={() => onUnfollow(follower)}
                                    >
                                        <FaUserMinus className="me-2" />
                                        Remove
                                    </Button>
                                    <Button
                                        variant="danger"
                                        className="follower-action-btn"
                                        onClick={() => onBlock(follower)}
                                    >
                                        <FaBan className="me-2" />
                                        Block
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="follower-action-btn"
                                        onClick={() => onChat(follower)}
                                    >
                                        <FaComments className="me-2" />
                                        Chat
                                        {unreadMsg?.unreadCount > 0 && (
                                            <Badge bg="warning" text='dark' className='ms-1'>{unreadMsg?.unreadCount}</Badge>
                                        )}
                                        <span className="visually-hidden">unread messages</span>
                                    </Button>

                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div className='empty-followers text-center'>
                    <FaUserCircle size={64} className="empty-icon mb-3" />
                    <h6>No Followers Yet</h6>
                    <p className="text-muted">You don't have any followers at the moment.</p>
                </div>
            )}
            <BiolinkQRCode qrShow={qrShow} setQRShow={setQRShow} qrCode={qrCode} />
        </>
    )
}

